import { GiftshopEditModel, GiftshopLoginRequest, GiftshopLoginResponse, GiftshopOrderEditModel } from '@/models/Giftshop';
import axios, { AxiosResponse } from 'axios';

export default class GiftshopService {

    private profileId: string = (window as any).CbxApiContextKey;
    private endpoint: string;

    constructor(args: any = {}) {
        if (args.profileId)
            this.profileId = args.profileId;
        this.endpoint = `/contextapi/${this.profileId}/v1/giftshop`;
    }

    public async signIn(request: GiftshopLoginRequest): Promise<GiftshopLoginResponse> {
        try {
            const res: AxiosResponse<any> = await axios.post(`${this.endpoint}/signin`, request);
            return res.data;
        } catch (e) {
            console.log(e);
            return GiftshopLoginResponse.ERROR;
        }
    }

    public async signOut(): Promise<boolean> {
        try {
            await axios.post(`${this.endpoint}/signout`);
            return true;
        } catch (e) {
            console.log(e);
            return false;
        }
    }

    public async persistOrder(request: GiftshopOrderEditModel): Promise<boolean> {
        try {
            await axios.post(`${this.endpoint}/order`, request);
            return true;
        } catch (e) {
            console.log(e);
            return false;
        }
    }

    public async addGiftshop(request: GiftshopEditModel): Promise<boolean> {
        try {
            await axios.post(`${this.endpoint}/giftshop`, request);
            return true;
        } catch (e) {
            console.log(e);
            return false;
        }
    }
}
